import React, { Fragment } from 'react';
import { bool, object, string, func } from 'prop-types';
import styled from 'styled-components';
import ProductsTitle from '../../../products/products-title/ProductsTitle';
import Balance from '../../components/balance/BalanceWrapperContainer';

const Container = styled.aside`
  position: relative;
  text-align: center;

  @media(min-width: 1000px) {
    margin: 0;
  }
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  background-color: #ffff;
  align-items: center;
  flex-direction: column;
  border-top: 1px solid #d2d2d2;
  padding: 16px 0px;
  @media(min-width: 1000px) {
    padding: 32px 0px 16px;
  }
`;

const SellFast = styled.p`
  margin: 16px 0px 22px 0px;
  line-height: 1.5;
  color: #4a4a4a;

  @media(min-width: 1000px) {
    margin: 32px 0px 24px 0px;
    font-size: 20px;
    line-height: 1.4;
  }
`;
const AdditionalInfo = styled.div`
  color: #6E0AD6;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  padding-top: 8px;
  cursor: pointer;
  @media(min-width:1000px) {
    font-size : 20px;
  }
`;

const productNotBoughtMessage = adName => (
  <Fragment>
    Quer vender mais rápido? Destaque seu anúncio:
    <br />
    {`"${adName}"`}
  </Fragment>
);

const Header = ({
  content, type, limits, adName, purchased, ad, openModal,
}) => (
  <Container>
    <Section>
      <ProductsTitle title={content.title} type={type} />
      {type !== 'free-renewal-pro' ? <Balance balance={limits.balance.value} text={content.balance} show={limits.balance.show} ad={ad} /> : null}
      {content.additionalInfo && <AdditionalInfo onClick={openModal}>{content.additionalInfo }</AdditionalInfo>}
    </Section>
    <SellFast>
      {
        purchased ?
          content.productAlreadyBoughtMessage :
          productNotBoughtMessage(adName)
      }
    </SellFast>
  </Container>
);

Header.propTypes = {
  content: object.isRequired,
  type: string.isRequired,
  limits: object,
  adName: string.isRequired,
  purchased: bool,
  ad: object.isRequired,
  openModal: func.isRequired,
};

Header.defaultProps = {
  limits: { show: false, value: false },
  purchased: false,
};

export default Header;
